import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ArrowLeft, Home } from "lucide-react";
import { Button } from "../components/ui/button";

/**
 * Componente NotFound - Página de erro 404
 * 
 * Exibido quando o usuário acessa uma rota que não existe
 * Funcionalidades:
 * - Mensagem de erro amigável
 * - Botões de navegação para retornar à página inicial ou voltar
 * - Link para contato caso o usuário acredita que é um erro
 * - Metadados SEO específicos para página de erro (noindex)
 */
const NotFound = () => {
  return (
    <>
      {/* Metadados SEO para página de erro */}
      <Helmet>
        <title>Página não encontrada | Moacyr Moura Ferreira</title>
        <meta name="description" content="A página que você está procurando não foi encontrada." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      {/* Conteúdo principal da página de erro */}
      <div className="min-h-[70vh] flex flex-col items-center justify-center px-4 py-24">
        <div className="text-center max-w-2xl mx-auto">
          {/* Número 404 com efeito de gradiente */}
          <div className="relative mb-8">
            <div className="absolute -inset-1 rounded-full bg-gradient-to-r from-blue-600 to-blue-400 opacity-30 blur-xl"></div>
            <div className="relative bg-gray-100 dark:bg-gray-900 rounded-full p-6 inline-flex">
              <span className="text-7xl text-gray-900 dark:text-white">404</span>
            </div>
          </div>
          
          {/* Título e mensagem de erro */}
          <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">Página não encontrada</h1>
          
          <p className="text-gray-600 dark:text-gray-400 text-lg mb-8">
            A página que você está procurando pode ter sido removida, renomeada ou está temporariamente indisponível.
          </p>
          
          {/* Botões de navegação */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {/* Botão para página inicial */}
            <Button 
              asChild
              variant="default" 
              size="lg"
              className="gap-2"
            >
              <Link to="/">
                <Home size={18} />
                Página Inicial
              </Link>
            </Button>
            
            {/* Botão para voltar à página anterior */}
            <Button 
              asChild
              variant="outline" 
              size="lg"
              className="gap-2"
              onClick={() => window.history.back()}
            >
              <button>
                <ArrowLeft size={18} />
                Voltar
              </button>
            </Button>
          </div>
          
          {/* Link para contato caso seja um erro */}
          <div className="mt-16">
            <p className="text-gray-500 dark:text-gray-500">
              Se você acredita que isso é um erro, por favor{" "}
              <Link to="/#contato" className="text-blue-600 dark:text-blue-400 hover:text-blue-500 dark:hover:text-blue-300 underline">
                entre em contato conosco
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
